module.exports = __webpack_public_path__ + "img/2-3.9656b1f5.jpg";